import axios from './Axios';
import { error, success } from "./ResponseHandler";
import GLOBAL from "../global";
import CONSTANT from "../constants/Constant";
import { getSubdomain } from "../utils/Utils";

const { REACT_APP_BASE_API_URL } = process.env;
const tenant = getSubdomain() || GLOBAL.TENANT;
const GET_ONBOARDING_PACKAGES_URL = REACT_APP_BASE_API_URL + `/api/${CONSTANT.CONTROLLER.DIRECTTOCONSUMER}/GetOnboardPriceList?Tenant=${tenant}`;

// Dummy data for testing
const dummyData = {
    Success: true,
    Message: [
        {
            id: "1",
            isBestValue: true,
            badge: "BEST VALUE",
            price: "$10/mo",
            title: "Membership",
            valueLabel: "Best Value",
            url: "https://buy.stripe.com/test_aFabJ164QdNh0Sf7bZ7AI01",
            features: [
                { label: "Ask EMMA", value: "FULL access" },
                { label: "Assessments", value: "1 available immediately" },
                { label: "Ongoing", value: "1 new assessment every 90 days (4/year)" }
            ]
        },
        {
            id: "2",
            isBestValue: false,
            price: "$59.99",
            title: "One-time Baseline Assessment",
            url: "https://buy.stripe.com/test_cN25nS0X41Xxd2w3cc",
            features: [
                { label: "Assessments", value: "Only 1" },
                { label: "Ask EMMA", value: "locked or very limited" }
            ]
        }
    ]
};

class OnboardingService {
    async getPackages(payload = {}) {
        try {
            payload.Tenant = GLOBAL.TENANT;
            const response = await axios.get(GET_ONBOARDING_PACKAGES_URL);
            return success(response);
        } catch (e) {
            return error(e);
        }
    }
}

export default new OnboardingService();
